import { CheckCircleIcon } from '@heroicons/react/solid';
import { Modal, Skeleton } from '@luminalearning/components';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

type Props = {
    isOpen: boolean,
    setOpen: (value: boolean) => void;
    brandfolderSignUp: Function;
    isBrandfolderSignUp: boolean;
    brandfolderError: boolean;
};

const BrandfolderSignupModal = (props: Props) => {
    const {
        isOpen,
        setOpen,
        isBrandfolderSignUp,
        brandfolderSignUp,
        brandfolderError,
    } = props;
    const intl = useIntl();

    useEffect(() => {
        if (isOpen) {
            brandfolderSignUp();
        }
    // eslint-disable-next-line
    }, [isOpen]);

    useEffect(() => {
        setOpen(false);
        // eslint-disable-next-line
    }, [brandfolderError]);

    return (
        <Modal
            className='w-auto h-auto max-h-70 overflow-auto p-20'
            isOpen={isOpen}
            setOpen={setOpen}
            children={
                <div className='flex flex-col space-y-8'>
                    {isBrandfolderSignUp
                        && <><div className='text-headline-reg font-bold'>
                            {intl.formatMessage({
                                id: 'LP_BRANDFOLDER_INVITE',
                                defaultMessage: 'You have been invited to the Brandfolder Resource Library',
                            })}
                        </div><div className='flex flex-row items-center'>
                            <CheckCircleIcon width='4rem'
                                className='inline fill-validation-success text-logo-regular mr-4' />
                            <span>
                                <p className=' text-label-lg font-bold'>
                                    {intl.formatMessage({
                                        id: 'LP_BRANDFOLDER_EMAIL',
                                        defaultMessage: 'An invitation has been sent to your email address.',
                                    })}
                                </p>
                            </span>
                        </div></>
                    }
                    {!isBrandfolderSignUp
                         && <><div className='text-headline-reg font-bold'>
                             {intl.formatMessage({
                                 id: 'LP_BRANDFOLDER_SENDING_INVITE',
                                 defaultMessage: 'Sending invite',
                             })}
                         </div><div className='flex flex-row items-center'>
                             <Skeleton circle={true} style={{ width: '4rem', height: '4rem' }} />
                             <span className='ml-10'>
                                 <p className=' text-label-lg font-bold mr-10'>
                                     <Skeleton
                                         baseColor='#d7d7d7'
                                         highlightColor='#c8c8c8'
                                         height={15}
                                         width={300}
                                     />
                                 </p>
                                 <span className='inline-flex'>
                                     <Skeleton
                                         baseColor='#d7d7d7'
                                         highlightColor='#c8c8c8'
                                         height={15}
                                         width={300}
                                     />
                                 </span>
                             </span>
                         </div></>
                    }
                </div>

            }
        />
    );
};

export default BrandfolderSignupModal;